<template>
  <div class="m-edition-section-content-footer">
    <span>Creado con</span>
    <a
      href="https://vidroop.com/vidroop"
      class="text-link-hover-academy font-weight-bold"
      target="_blank"
    >
      <img src="@/assets/img/logo.png" alt="Vidroop.com" height="17">
    </a>
    <span>© {{ $moment().year() }}</span>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionSectionContentFooter'
}
</script>
